export const STORE_NAME = 'core/block-editor';
//# sourceMappingURL=constants.js.map